import { DirectExperienceExpiredResponse } from '@ads-bread/shared/bread/codecs';
import { APIFetch, APIResponse } from '../hooks/apiFetch';
import { HandlerResponse, handleResponse } from './base';

export const GET_DIRECT_EXPERIENCE_EXPIRED_PATH =
  '/api/direct-experience-expired';

export async function getDirectExperienceExpired(
  merchantID: string,
  buyerID: string,
  apiFetch: APIFetch
): Promise<HandlerResponse<DirectExperienceExpiredResponse>> {
  const res: APIResponse<DirectExperienceExpiredResponse> =
    await apiFetch<DirectExperienceExpiredResponse>(
      `${GET_DIRECT_EXPERIENCE_EXPIRED_PATH}?merchantID=${merchantID}&buyerID=${buyerID}`,
      { method: 'GET' },
      DirectExperienceExpiredResponse
    );
  const response = handleResponse(res);

  return response;
}
